import { gql } from '@apollo/client'

export const GQL_QUERY_ALL_BANNERS = gql`
  query AllBanners($pager: CommonPagerInput, $style: String, $bannerMobileSlideStyle2: String, $filter: NestedFilterInput) {
    allBanners(pager: $pager, filter: $filter) {
      edges {
        id
        name
        url
        status
        
        has_button
        button_text
        button_color

        bannerSlide(style: $style) {
          url
        }
        bannerMobileSlide(style: $bannerMobileSlideStyle2) {
          url
        }
        optionOpenInNewWindow
        optionOpenInBrowser
      }
    }
  }
`

export const GQL_QUERY_BANNER = gql`
  query Banner($id: ID!) {
    banner(id: $id) {
      id
      name
      url
      status
      
      has_button
      button_text
      button_color

      bannerSlide(style: $style) {
        url
      }
      bannerMobileSlide(style: $bannerMobileSlideStyle2) {
        url
      }
      optionOpenInNewWindow
      optionOpenInBrowser
    }
  }
`